import { componentDidMount } from '../../components/Lifecycles'
import { compose } from 'ramda'
import { connect } from 'react-redux'
import { redirect } from '../../store/modules/router'

const mapDispatchToProps = dispatch => ({
  redirect: compose(dispatch, redirect),
})

// didMount :: Props -> Action
const didMount = ({ redirect, to }) => redirect(to)

// View :: () -> _
const View = () => null

// component :: React.Component -> React.Component
const component = componentDidMount(didMount)(View)

export default connect(
  null,
  mapDispatchToProps,
)(component)
